import { strings } from "@quickpoint.me/shared";

export const getOwnerNameFromSessionStorage = (): string | null => {
    return sessionStorage.getItem(strings.localStorage.ownerName);
};

export const setOwnerNameToSessionStorage = (name: string): void => {
    sessionStorage.setItem(strings.localStorage.ownerName, name);
};

export const clearOwnerNameFromSessionStorage = (): void => {
    sessionStorage.removeItem(strings.localStorage.ownerName);
};
